import script from "./AdvisorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisorPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdvisorPanel.vue?vue&type=style&index=0&id=781bcb9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781bcb9c"]])

export default __exports__